import { HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { OrdersModel, OrdersServerModel } from '@domain/entities/orders.model';

export abstract class OrdersGateway {
    abstract read(params?: HttpParams): Observable<OrdersServerModel[]>;
    abstract create(form: OrdersModel): Observable<OrdersServerModel>;
    abstract readById(id: number): Observable<OrdersServerModel>;
    abstract update(
        id: number,
        form: OrdersModel
    ): Observable<OrdersServerModel>;
    abstract delete(id: number): Observable<OrdersServerModel>;
}
